import type { FC, ReactElement } from 'react';
import { QButton } from '../../QAtoms';
import { QConfirmationModal } from '../ConfirmationModal/ConfirmationModal';
import { QModalActions } from '../../QComponents';
import { useLibraryTranslation } from '../../i18n';

export type QDeleteConfirmationModalProps = {
  onConfirm: () => void;
  onClose: () => void;
  title: string;
  message: ReactElement;
  inProgress?: boolean;
};
export const QDeleteConfirmationModal: FC<QDeleteConfirmationModalProps> = ({
  onConfirm,
  onClose,
  title,
  message,
  inProgress,
}) => {
  const { t } = useLibraryTranslation();
  return (
    <QConfirmationModal
      isOpen
      onClose={onClose}
      title={title}
      message={message}
      data-cy="delete-confirmation-modal"
    >
      <QModalActions>
        <QButton
          variant="outline"
          isDisabled={inProgress}
          onClick={onClose}
          data-cy="cancel-delete-btn"
        >
          {t('common.cancel')}
        </QButton>
        <QButton
          isDestructive
          isLoading={inProgress}
          onClick={onConfirm}
          data-cy="confirm-delete-btn"
        >
          {t('common.delete')}
        </QButton>
      </QModalActions>
    </QConfirmationModal>
  );
};
